import React from 'react'
import { Route, Switch, useHistory, useLocation } from 'react-router-dom'

import { SubMenu } from '../components'
import { Header } from '../components'
import { Paths } from '../config/routes'
import { ProfileContextProvider } from '../contexts/settings/profile'
import { usePixel } from '../hooks/use-pixel'
import { UpdateProfile } from '../pages/update-profile'

export function SettingsRouter() {
    const history = useHistory()
    const location = useLocation()
    usePixel({ page: 'Settings' })

    const handlePath = (path: string) => history.push(path)
    return (
        <>
            <Header />
            <div
                className='w-full lg:px-24 px-4 flex flex-col py-4'
                style={{ height: '89vh' }}>
                <SubMenu
                    options={[
                        {
                            children: 'User Settings',
                            selected: location.pathname.includes('settings'),
                            onClick: () => handlePath(Paths.UPDATE_PROFILE),
                        },
                    ]}
                />
                <Switch>
                    <Route path={Paths.SETTINGS}>
                        <ProfileContextProvider>
                            <UpdateProfile />
                        </ProfileContextProvider>
                    </Route>
                </Switch>
            </div>
        </>
    )
}
